module.exports = __webpack_public_path__ + "img/chakpakaal.694e3d5e.png";